import type * as Types from '@shared/types/graphqlGenerated';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
export type FeaturedProductsEmersonQueryVariables = Types.Exact<{
  productIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type FeaturedProductsEmersonQuery = { viewer: { __typename: 'Viewer', product: Array<{ __typename: 'Product', id: string, name: string, brandName: string, image: string, slug: string | null, availableOrMasterVariant: { __typename: 'Variant', id: string, emersonVariantId: string | null } } | null | { __typename: string }>; } | null; };


export const FeaturedProductsEmersonQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FeaturedProducts_Emerson_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"product"},"name":{"kind":"Name","value":"nodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"brandName"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"availableOrMasterVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emersonVariantId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export type FeaturedProductsEmersonQueryQueryResult = Apollo.QueryResult<FeaturedProductsEmersonQuery, FeaturedProductsEmersonQueryVariables>;

export function useFeaturedProductsEmersonQuery(baseOptions?: Apollo.QueryHookOptions<FeaturedProductsEmersonQuery, FeaturedProductsEmersonQueryVariables>) {
  const result = Apollo.useQuery<FeaturedProductsEmersonQuery, FeaturedProductsEmersonQueryVariables>(
    FeaturedProductsEmersonQueryDocument,
    baseOptions
  );
  const viewer_product_value = result.data?.viewer?.product;
  const viewer_product = Array.isArray(viewer_product_value)
  ? viewer_product_value.reduce((acc, item) => {
      if (item && item.__typename && ['Product'].includes(item.__typename)) {
        acc.push(item as Extract<NonNullable<NonNullable<FeaturedProductsEmersonQuery>['viewer']>['product'][number], { __typename: 'Product' }>);
      }
      return acc;
    }, [] as Extract<NonNullable<NonNullable<FeaturedProductsEmersonQuery>['viewer']>['product'][number], { __typename: 'Product' }>[])
  : [];

  const narrowed = result.data ? {
    ...result.data,
    viewer: {
      ...result.data?.viewer,
      product: viewer_product,
    },
  } : null;

  return { ...result, data: narrowed };
}

export function useFeaturedProductsEmersonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeaturedProductsEmersonQuery, FeaturedProductsEmersonQueryVariables>) {
  const [originalQuery, queryInfo] = Apollo.useLazyQuery<FeaturedProductsEmersonQuery, FeaturedProductsEmersonQueryVariables>(
    FeaturedProductsEmersonQueryDocument,
    baseOptions
  );

  const narrowedQuery = (options?: Apollo.QueryOptions<FeaturedProductsEmersonQueryVariables>) => {
    return originalQuery(options).then(result => {
  const viewer_product_value = result.data?.viewer?.product;
  const viewer_product = Array.isArray(viewer_product_value)
  ? viewer_product_value.reduce((acc, item) => {
      if (item && item.__typename && ['Product'].includes(item.__typename)) {
        acc.push(item as Extract<NonNullable<NonNullable<FeaturedProductsEmersonQuery>['viewer']>['product'][number], { __typename: 'Product' }>);
      }
      return acc;
    }, [] as Extract<NonNullable<NonNullable<FeaturedProductsEmersonQuery>['viewer']>['product'][number], { __typename: 'Product' }>[])
  : [];

  const narrowed = result.data ? {
    ...result.data,
    viewer: {
      ...result.data?.viewer,
      product: viewer_product,
    },
  } : null;

  return { ...result, data: narrowed };
    });
  };

  return [narrowedQuery, queryInfo] as const;
}

export function useFeaturedProductsEmersonSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FeaturedProductsEmersonQuery, FeaturedProductsEmersonQueryVariables>) {
  const result = Apollo.useSuspenseQuery<FeaturedProductsEmersonQuery, FeaturedProductsEmersonQueryVariables>(
    FeaturedProductsEmersonQueryDocument,
    baseOptions
  );
  const viewer_product_value = result.data?.viewer?.product;
  const viewer_product = Array.isArray(viewer_product_value)
  ? viewer_product_value.reduce((acc, item) => {
      if (item && item.__typename && ['Product'].includes(item.__typename)) {
        acc.push(item as Extract<NonNullable<NonNullable<FeaturedProductsEmersonQuery>['viewer']>['product'][number], { __typename: 'Product' }>);
      }
      return acc;
    }, [] as Extract<NonNullable<NonNullable<FeaturedProductsEmersonQuery>['viewer']>['product'][number], { __typename: 'Product' }>[])
  : [];

  const narrowed = result.data ? {
    ...result.data,
    viewer: {
      ...result.data?.viewer,
      product: viewer_product,
    },
  } : null;

  return { ...result, data: narrowed };
}
